import Image, { AutoImageWrapper } from '~/components/Image';

interface Props {
  className?: string;
  termsImage: string;
}
const Terms = ({ className, termsImage }: Props) => {
  return (
    <AutoImageWrapper className={className}>
      <Image src={termsImage} alt="" layout="fill" />
    </AutoImageWrapper>
  );
};

export default Terms;
